var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select-wrapper" }, [
    _c(
      "div",
      { class: _vm.classList },
      [
        _vm.label
          ? _c(
              "v-typo",
              {
                staticClass: "select__label",
                attrs: {
                  for: _vm.fieldName,
                  element: "label",
                  variant: "form-label"
                }
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.label) + "\n\t\t")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            ref: "select",
            staticClass: "select__item",
            attrs: {
              id: _vm.fieldName,
              disabled: _vm.disabled,
              tabIndex: _vm.tabIndex || -1,
              "data-hovered": "true"
            },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.value = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(_vm.options, function(option, optionIndex) {
            return _c("option", {
              key: _vm.fieldName + "-" + optionIndex,
              domProps: { value: option.value, innerHTML: _vm._s(option.label) }
            })
          }),
          0
        ),
        _vm._v(" "),
        _c("v-icon", {
          attrs: { "data-hovered": "true", name: "ui/select-arrow" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "errorMessage", staticClass: "select__error" },
      [
        _c(
          "transition",
          {
            attrs: { name: "roll" },
            on: {
              enter: _vm.errorAnimationEnter,
              leave: _vm.errorAnimationLeave,
              "after-enter": _vm.errorAnimationAfterEnter
            }
          },
          [
            !_vm.isValid && _vm.required
              ? _c(
                  "div",
                  { ref: "errorPerex", staticClass: "select__error-container" },
                  [
                    _c("v-typo", { attrs: { variant: "body-paragraph" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("error.form.required")) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }